import { takeLatest } from 'redux-saga/effects';
import { postSignupRequestSaga } from './saga';
import { POST_CREATE_TENANT_REQUEST } from '../consts';

export default function* watchSignup() {
  yield takeLatest(POST_CREATE_TENANT_REQUEST, postSignupRequestSaga);
}
